module.exports = {
      id: "user-icon-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-1d11361007108583c67c4a96e18e035a.svg#user-icon",
      toString: function () {
        return this.url;
      }
    }